import React, {useEffect, useState} from "react";

import {useDispatch} from "react-redux";
const User = () => {

    const dispatch = useDispatch();
    useEffect(() => {

    }, []);

    return (<></>);

}

export default User;
